import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const keyWrapperStyles = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

export const keyHeadingStyles = style({
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.m,
});

export const keyItemsStyles = style({
  display: "flex",
  gap: vars.space["2xs"],
  fontFamily: vars.fonts.bold,
  fontWeight: 400,
});

export const keyLabelsStyles = style({
  display: "flex",
  justifyContent: "space-between",
  marginTop: "0.2rem",
});

export const keyLabelStyles = style({
  color: vars.colors.onSurfaceVariant,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
  fontWeight: 400,
});
